/** Rótulo de seção da trilha lateral (padrão sidebar do VerticalTabLayout). */
export default function RailHeader({ label }) {
  return (
    <div className="px-4 pt-3 pb-1">
      <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
        {label}
      </span>
    </div>
  );
}
